import { BankyLogoBlue } from '@images'
import cn from '@integrations/classnames'
import { Link } from '@integrations/routing'
import { paths } from 'mmfintech-backend-api'
import styles from './BankyLogo.module.scss'

function BankyLogo() {
  return (
    <div className={cn(styles['banky-logo-wrapper'], 'banky-logo-wrapper')}>
      <Link to={paths.root()}>
        <img src={BankyLogoBlue} alt='Logo' />
      </Link>
    </div>
  )
}

export default BankyLogo
